export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-grove-bsub py-12 px-6 lg:px-12 bg-grove-alt text-grove-mute"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <svg
            className="w-5 h-5 text-grove-deep"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
          >
            <path d="M16 3L4 27h24L16 3z" stroke="currentColor" strokeWidth="2" />
          </svg>
          <span className="font-disp font-semibold text-grove-ink">
            equitygrove
          </span>
          <span className="text-xs font-mono ml-2">
            &copy; 2025 All rights reserved.
          </span>
        </div>
        <div className="text-xs font-mono text-[#6B7280]">
          Founder Contact:{" "}
          <span className="text-grove-ink font-medium">Christopher Ortega</span>
        </div>
      </div>
    </footer>
  );
};
